import React from 'react';
import Outer from '../../Templates/Outer';
import { Login } from '../../pageListAsync';

function LoginDedicated() {
  return (
    <Outer>
      <Login />
    </Outer>
  );
}

export default LoginDedicated;
